module.exports = __webpack_public_path__ + "static/media/loading-button.8799f5d6.svg";